import { ShoppingCart } from '../../../types'
import centsToDollars from '../../../utils/centsToDollars'
import FlowerProduct from '../FlowerProduct'
import MemorialTreeModel from '../MemorialTreeModel'

const CartModel = {
  billingAddressLine1: (cart: ShoppingCart): string => {
    return [cart.billing_address_line_1, cart.billing_address_line_2].filter(Boolean).join(', ')
  },
  billingAddressLine2: (cart: ShoppingCart): string => {
    const cityAndState = [cart.billing_city, cart.billing_state].filter(Boolean).join(', ')

    return [cityAndState, cart.billing_zip].join(' ')
  },
  billingFullName: (cart: ShoppingCart): string => {
    return [cart.billing_first_name, cart.billing_last_name].filter(Boolean).join(' ')
  },
  hasProducts: (cart: ShoppingCart): boolean => {
    return CartModel.hasFlowerProducts(cart) || CartModel.hasTreeProducts(cart)
  },
  hasTreeProducts: (cart: ShoppingCart): boolean => {
    return Boolean(cart.memorial_tree_shopping_cart_items.length)
  },
  hasFlowerProducts: (cart: ShoppingCart): boolean => {
    return Boolean(cart.flower_shopping_cart_items.length)
  },
  shippingAddressLine1: (cart: ShoppingCart): string => {
    return [cart.shipping_address_line_1, cart.shipping_address_line_2].filter(Boolean).join(', ')
  },
  shippingAddressLine2: (cart: ShoppingCart): string => {
    const cityAndState = [cart.shipping_city, cart.shipping_state].join(', ')

    return [cityAndState, cart.shipping_zip].join(' ')
  },
  flowerSubtotalInDollars: (cart: ShoppingCart): number => {
    const subtotalInCents = cart.flower_subtotal_in_cents || 0

    return parseFloat(centsToDollars(subtotalInCents))
  },
  taxInDollars: (cart: ShoppingCart): number => {
    const taxInCents = cart.tax_in_cents || 0

    return parseFloat(centsToDollars(taxInCents))
  },
  deliveryChargeInDollars: (cart: ShoppingCart): number => {
    const deliveryChargeInCents = cart.delivery_charge_in_cents || 0

    return parseFloat(centsToDollars(deliveryChargeInCents))
  },
  flowerOrderTotalInDollars: (cart: ShoppingCart): number => {
    const flowerOrderTotalInCents = cart.flower_order_total_in_cents || 0

    return parseFloat(centsToDollars(flowerOrderTotalInCents))
  },
  totalProductQuantity: (cart: ShoppingCart): number =>
    FlowerProduct.productsQuantity(cart.flower_shopping_cart_items) +
    MemorialTreeModel.productsQuantity(cart.memorial_tree_shopping_cart_items),
}

export default CartModel
